export default (sizeInBytes: number, decimal = 2) =>
  +(sizeInBytes / (1024 * 1024)).toFixed(decimal);
